import $script from 'scriptjs';
import axios from 'axios';
import { triggerCustomEvent } from 'lib/helpers';

import {
  socialSessionLoading,
  socialSessionError,
  socialSessionFromFollow,
} from 'lib/social-session-helpers';

export default class GoogleLogin {
  constructor({
    buttonTarget, textTarget = null, csrfToken, omniauthToken,
  }) {
    this.buttonTarget = buttonTarget;
    this.textTarget = textTarget;
    this.csrfToken = csrfToken;
    this.omniauthToken = omniauthToken;
    this.handleGoogleResponse = this.handleGoogleResponse.bind(this);
    this.handleError = this.handleError.bind(this);
    this.init();
  }

  init() {
    socialSessionError(false, this.buttonTarget);

    $script('https://apis.google.com/js/platform.js', this.loadGoogleApi);
  }

  loadGoogleApi = () => {
    window.gapi.load('auth2');
  }

  connect() {
    if (this.textTarget) {
      this.originalText = this.textTarget.innerHTML;

      socialSessionLoading(this.buttonTarget);
    }

    socialSessionError(false, this.buttonTarget);

    this.login();
  }

  login() {
    window.gapi.auth2.authorize({
      client_id: this.buttonTarget.dataset.appId,
      cookie_policy: 'single_host_origin',
      scope: 'email profile',
      response_type: 'code',
    }, this.handleGoogleResponse);
  }

  handleGoogleResponse(response) {
    if (response && !response.error) {
      // google authentication succeed, now post data to server.
      const newsletter = document.getElementById('user_newsletter');
      let newsletterValue = false;
      if (newsletter !== null && newsletter.type !== 'hidden') {
        newsletterValue = newsletter.checked;
      } else if (newsletter !== null && newsletter.type === 'hidden') {
        newsletterValue = true;
      }

      const fromFollow = socialSessionFromFollow();

      axios.defaults.headers.common['X-CSRF-Token'] = this.csrfToken;
      axios.post(`/users/auth/google_oauth2/callback?state=${this.omniauthToken}&newsletter=${newsletterValue}`, response).then((req) => {
        if (req.status === 200) {
          // using the content type header to check if it's javascript
          // the google login/signup normally uses html content-type, but
          // we force javascript on signups so we can display the signup survey modal
          if (req.headers['content-type'] === 'text/javascript; charset=utf-8') {
            // we have to eval the modal injector code coming back
            eval(req.data); // eslint-disable-line no-eval
          } else if (fromFollow) {
            window.location.reload();
          } else if (req.data.message === 'login_in_place') {
            triggerCustomEvent('LoggedInPlace');
          } else {
            window.location.assign(req.request.responseURL);
          }
        } else { this.handleError(); }
      }).catch(this.handleError);
    } else { this.handleError(); }
  }

  handleError() {
    if (this.textTarget) socialSessionLoading(this.buttonTarget, this.originalText);
    socialSessionError(true, this.buttonTarget);
  }
}
